/**
 * Статус корректного ответа
 */
export const API_STATUS_OK = 'ok'

/**
 * Статус ответа с ошибкой
 */
export const API_STATUS_ERROR = 'error'

/**
 * Статус ответа с ошибкой токена авторизации
 */
export const API_STATUS_INVALID_TOKEN = 'invalid_token'

/**
 * Версия эндпоинтов API по умолчанию
 */
export const API_DEFAULT_VERSION = 2

export enum HTTP_RESPONSE_CODE {
  OK = 200,
  /**
   * Не авторизован
   */
  UNAUTHORIZED = 401,
  FORBIDDEN = 403,
  NOT_FOUND = 404,
  NOT_ALLOWED = 405,
  NOT_ACCEPTABLE = 406,
  /**
   * Тело запроса больше лимита (nginx / gateway client_max_body_size).
   */
  PAYLOAD_TOO_LARGE = 413,
  /**
   * Сумма оплаты превышает допустимый размер платежа
   */
  RANGE_NOT_SATISFIABLE = 416,
  /**
   * Токен авторизации протух, его надо обновить
   */
  TOKEN_EXPIRED = 498,
  /**
   * Превышен лимит запросов
   */
  TOO_MANY_REQUESTS = 429,
  SERVER_ERROR = 500,

  UNPROCESSABLE_ENTITY = 422,
  SERVER_TIMEOUT = 522,
}

/**
 * Таймаут для повторяющихся запросов к API
 */
export const API_REQUEST_INTERVAL = 2000

export enum API_KNOWN_ERRORS {
  ACCOUNT_LOCKED = 'ACCOUNT_LOCKED',
  BANK_NOT_FOUND = 'BANK_NOT_FOUND',
  CARD_ALREADY_ISSUED = 'CARD_ALREADY_ISSUED',
  CARD_NOT_FOUND = 'CARD_NOT_FOUND',
  CODE_EXPIRED = 'CODE_EXPIRED',
  CODE_INVALID_OR_EXPIRED = 'CODE_INVALID_OR_EXPIRED',
  EXCHANGE_RATE_SERVICE_UNAVAILABLE = 'EXCHANGE_RATE_SERVICE_UNAVAILABLE',
  IDEMPOTENCY_EXPIRED = 'IDEMPOTENCY_EXPIRED',
  IDEMPOTENCY_ALREADY_USED = 'IDEMPOTENCY_ALREADY_USED',
  INVALID_CARD_STATUS = 'INVALID_CARD_STATUS',
  INVALID_INIT_DATA = 'INVALID_INIT_DATA',
  NOT_ENOUGH_MONEY = 'NOT_ENOUGH_MONEY',
  OTP_RATE_LIMIT_EXCEEDED = 'OTP_RATE_LIMIT_EXCEEDED',
  PHONE_ALREADY_EXISTS = 'PHONE_ALREADY_EXISTS',
  PHONE_REQUIRED = 'PHONE_REQUIRED',
  RUSSIAN_PHONE_REQUIRED = 'RUSSIAN_PHONE_REQUIRED',
  SBP_SERVICE_UNAVAILABLE = 'SBP_SERVICE_UNAVAILABLE',
  TEMPLATE_NOT_FOUND = 'TEMPLATE_NOT_FOUND',
  TG_ALREADY_LINKED = 'TG_ALREADY_LINKED',
  TOKEN_NOT_FOUND = 'TOKEN_NOT_FOUND',
  TOKEN_PENDING = 'TOKEN_PENDING',
  TOPUP_MIN_LIMIT_ERROR = 'TOPUP_MIN_LIMIT_ERROR',
  TOPUP_MAX_LIMIT_ERROR = 'TOPUP_MAX_LIMIT_ERROR',
  WITHDRAW_MIN_LIMIT_ERROR = 'WITHDRAW_MIN_LIMIT_ERROR',
  WITHDRAW_MAX_LIMIT_ERROR = 'WITHDRAW_MAX_LIMIT_ERROR',
  TOTP_REQUIRED = 'TOTP_REQUIRED',
  TX_NOT_FOUND = 'TX_NOT_FOUND',
  OPERATION_ALREADY_PENDING = 'OPERATION_ALREADY_PENDING',
  TOPUP_LIMIT_ERROR = 'TOPUP_LIMIT_ERROR',
  TOPUP_HOURLY_LIMIT_ERROR = 'TOPUP_HOURLY_LIMIT_ERROR',
  WITHDRAWAL_LIMIT_ERROR = 'WITHDRAWAL_LIMIT_ERROR',
  CAPTCHA_REQUIRED = 'CAPTCHA_REQUIRED',
  CAPTCHA_INVALID = 'CAPTCHA_INVALID',
  CAPTCHA_UNAVAILABLE = 'CAPTCHA_UNAVAILABLE',
  SMS_LIMIT_EXCEEDED = 'SMS_LIMIT_EXCEEDED',

  BIN_CHECK_COUNTRY_NOT_FOUND = 'BIN_CHECK_COUNTRY_NOT_FOUND',
  BANK_NOT_SUPPORTED = 'BANK_NOT_SUPPORTED',
  INVALID_CARD_BIN_FOR_CURRENCY = 'INVALID_CARD_BIN_FOR_CURRENCY',
  PASSPORT_DATA_UNAVAILABLE = 'PASSPORT_DATA_UNAVAILABLE',
  NO_AVAILABLE_PROVIDER = 'NO_AVAILABLE_PROVIDER',
  AMOUNT_BELOW_MINIMUM = 'AMOUNT_BELOW_MINIMUM',
  AMOUNT_ABOVE_MAXIMUM = 'AMOUNT_ABOVE_MAXIMUM',
  DIRECTION_UNAVAILABLE = 'DIRECTION_UNAVAILABLE',
  INVALID_CODE = 'INVALID_CODE',
  INVALID_EMAIL = 'INVALID_EMAIL',
  EMAIL_ALREADY_EXISTS = 'EMAIL_ALREADY_EXISTS',
  USER_ALREADY_HAVE_AN_ACTIVE_EMAIL = 'USER_ALREADY_HAVE_AN_ACTIVE_EMAIL',
  DISPOSABLE_EMAIL_NOT_ALLOWED = 'DISPOSABLE_EMAIL_NOT_ALLOWED',
  USER_DOES_NOT_HAVE_ANY_EMAIL = 'USER_DOES_NOT_HAVE_ANY_EMAIL',
  TG_ALREADY_LINKED_TO_ANOTHER_ACCOUNT = 'TG_ALREADY_LINKED_TO_ANOTHER_ACCOUNT',
  TOKEN_EXPIRED = 'TOKEN_EXPIRED',
  AMOUNT_TOO_LOW = 'AMOUNT_TOO_LOW',
  SERVICE_UNAVAILABLE = 'SERVICE_UNAVAILABLE',
  SOMETHING_WENT_WRONG = 'SOMETHING_WENT_WRONG',
  WITHDRAWAL_REQUEST_IS_ROTTEN = 'WITHDRAWAL_REQUEST_IS_ROTTEN',
  NETWORK_WITHDRAWALS_DISABLED = 'NETWORK_WITHDRAWALS_DISABLED',
  SERVICE_TEMPORARILY_UNAVAILABLE = 'SERVICE_TEMPORARILY_UNAVAILABLE',
  DO_NOT_USE_INTERNAL_ADDRESS_FOR_WITHDRAW = 'DO_NOT_USE_INTERNAL_ADDRESS_FOR_WITHDRAW',
  TO_ADDRESS_IS_NOT_CORRECT = 'TO_ADDRESS_IS_NOT_CORRECT',
  TO_ADDRESS_IS_NOT_CORRECT_TRON_ADDRESS = 'TO_ADDRESS_IS_NOT_CORRECT_TRON_ADDRESS',
  TO_ADDRESS_IS_NOT_CORRECT_TON_ADDRESS = 'TO_ADDRESS_IS_NOT_CORRECT_TON_ADDRESS',
  TO_ADDRESS_IS_NOT_CORRECT_BEP20_ADDRESS = 'TO_ADDRESS_IS_NOT_CORRECT_BEP20_ADDRESS',
  INVALID_TRX_ADDRESS = 'INVALID_TRX_ADDRESS',
  RECIPIENT_NOT_FOUND = 'RECIPIENT_NOT_FOUND',
  TOO_MANY_REQUESTS = 'TOO_MANY_REQUESTS',
  YOU_CANT_SEND_MONEY_TO_YOURSELF = 'YOU_CANT_SEND_MONEY_TO_YOURSELF',
  NOT_ENOUGH_MONEY_FOR_SELL = 'NOT_ENOUGH_MONEY_FOR_SELL',
  NOT_ENOUGH_MONEY_FOR_WITHDRAW = 'NOT_ENOUGH_MONEY_FOR_WITHDRAW',
  MUST_BE_LESS_THAN = 'MUST_BE_LESS_THAN',
  MUST_BE_LESS_THAN_OR_EQUAL_SUM = 'MUST_BE_LESS_THAN_OR_EQUAL_SUM',
  MUST_BE_GREATER_THAN = 'MUST_BE_GREATER_THAN',
  MUST_BE_GREATER_THAN_OR_EQUAL_SUM = 'MUST_BE_GREATER_THAN_OR_EQUAL_SUM',
  MUST_BE_FILLED = 'MUST_BE_FILLED',
  PHONE_NUMBER_MUST_BE_10_DIGITS = 'PHONE_NUMBER_MUST_BE_10_DIGITS',
  KYC_2_LEVEL_REQUIRED = 'KYC_2_LEVEL_REQUIRED',
  KYC_LEVEL_REQUIRED = 'KYC_LEVEL_REQUIRED',
  ONLY_RUSSIAN_PASSPORT_ALLOWED = 'ONLY_RUSSIAN_PASSPORT_ALLOWED',
  PASSPORT_DOCUMENT_REQUIRED = 'PASSPORT_DOCUMENT_REQUIRED',
  ADDRESS_BLACKLISTED = 'ADDRESS_BLACKLISTED',
  COUPON_ALREADY_ACTIVATED = 'COUPON_ALREADY_ACTIVATED',
  // бек (coupon/activate) шлёт код без префикса COUPON_
  ALREADY_ACTIVATED = 'ALREADY_ACTIVATED',
  COUPON_PAID_OUT = 'COUPON_PAID_OUT',
  RATE_LIMIT_IP = 'RATE_LIMIT_IP',
  SELF_ACTIVATION_NOT_ALLOWED = 'SELF_ACTIVATION_NOT_ALLOWED',
  YOU_ALREADY_HAVE_A_REFERRER = 'YOU_ALREADY_HAVE_A_REFERRER',
  THE_REFERRAL_CODE_BELONGS_TO_NO_ONE = 'THE_REFERRAL_CODE_BELONGS_TO_NO_ONE',
  "YOU_CAN'T_BE_A_REFERRAL_FOR_YOURSELF" = "YOU_CAN'T_BE_A_REFERRAL_FOR_YOURSELF",
  REQUEST_ERROR = 'REQUEST_ERROR',
  UNPROCESSABLE_ENTITY = 'UNPROCESSABLE_ENTITY',
  FULL_DISPUTE_ALREADY_EXISTS = 'FULL_DISPUTE_ALREADY_EXISTS',
  ALREADY_DELETED = 'ALREADY_DELETED',
  PHONE_NUMBER_CANNOT_BE_DELETED = 'PHONE_NUMBER_CANNOT_BE_DELETED',
  ACTIVE_REQUEST_EXISTS = 'ACTIVE_REQUEST_EXISTS',
  RATE_LIMIT_EXCEEDED = 'RATE_LIMIT_EXCEEDED',
  NO_ACTIVE_REQUEST = 'NO_ACTIVE_REQUEST',
  ALREADY_HARD_DELETED = 'ALREADY_HARD_DELETED',
  CANCELLATION_FAILED = 'CANCELLATION_FAILED',
  INTERNAL_FAILED_TO_CREATE_DISPUTE = 'INTERNAL_FAILED_TO_CREATE_DISPUTE',
  INTERNAL_FAILED_TO_PREPARE_PAYMENT = 'INTERNAL_FAILED_TO_PREPARE_PAYMENT',
  INTERNAL_FAILED_TO_CREATE_PAYMENT = 'INTERNAL_FAILED_TO_CREATE_PAYMENT',
  INTERNAL_FAILED_TO_PREPARE_TOP_UP = 'INTERNAL_FAILED_TO_PREPARE_TOP_UP',
  INTERNAL_FAILED_TO_CREATE_TOP_UP = 'INTERNAL_FAILED_TO_CREATE_TOP_UP',
  INTERNAL_FAILED_TO_CREATE_TRANSFER = 'INTERNAL_FAILED_TO_CREATE_TRANSFER',
  INVALID_TOKEN = 'INVALID_TOKEN',
  INVALID_QR_URL = 'INVALID_QR_URL',
  PAYMENT_AMOUNT_EXCEEDS_LIMIT_ERROR = 'PAYMENT_AMOUNT_EXCEEDS_LIMIT_ERROR',
  PS_TRANSACTION_LIMIT_EXCEEDED = 'PS_TRANSACTION_LIMIT_EXCEEDED',
  CARDS_LIMIT_REACHED = 'CARDS_LIMIT_REACHED',
  FEATURE_DISABLED = 'FEATURE_DISABLED',
  CARD_BUSY = 'CARD_BUSY',
  // World Card: по этому шаблону уже обрабатывается другой заказ - не отказ, а "повторите попытку".
  CARD_ISSUE_IN_PROGRESS = 'CARD_ISSUE_IN_PROGRESS',
  // Коды Antifraud::Gate (Swagger API v4, раздел Compliance). Gate накрывает все денежные операции —
  // crypto_withdrawal, sbp_payout, card_payment, qr_payment, swap, onramp, vcard_*, phone/steam topup.
  ANTIFRAUD_VERIFICATION_REQUIRED = 'ANTIFRAUD_VERIFICATION_REQUIRED',
  ANTIFRAUD_RESTRICTED = 'ANTIFRAUD_RESTRICTED',
  ANTIFRAUD_ADDRESS_BLOCKED = 'ANTIFRAUD_ADDRESS_BLOCKED',
  ANTIFRAUD_CHECK_REQUIRED = 'ANTIFRAUD_CHECK_REQUIRED',
  ANTIFRAUD_DISABLED = 'ANTIFRAUD_DISABLED',
  EXCHANGE_MIN_LIMIT_ERROR = 'EXCHANGE_MIN_LIMIT_ERROR',
  NO_AGENT_AVAILABLE = 'NO_AGENT_AVAILABLE',
  ALREADY_EXISTS = 'ALREADY_EXISTS',
  ALREADY_HAVE_PENDING_TOPUP_WITH_THIS_AMOUNT = 'ALREADY_HAVE_PENDING_TOPUP_WITH_THIS_AMOUNT',
  RESULT_NOT_AVAILABLE_STATUS_FAIL = 'RESULT_NOT_AVAILABLE. Status: fail',
  PHONE_ALREADY_EXISTS_FOR_COUNTRY = 'PHONE_ALREADY_EXISTS_FOR_COUNTRY',
  PHONE_ALREADY_USED = 'PHONE_ALREADY_USED',
  SAME_PHONE_NUMBER = 'SAME_PHONE_NUMBER',
  TOO_MANY_SMS = 'TOO_MANY_SMS',
  TOO_MANY_ATTEMPTS = 'TOO_MANY_ATTEMPTS',
  SIGN_RATE_LIMITED = 'SIGN_RATE_LIMITED',
  WRONG_SECURITY_CODE = 'WRONG_SECURITY_CODE',
  SECURITY_CODE_EXPIRED = 'SECURITY_CODE_EXPIRED',
  SECURITY_CODE_REQUIRED = 'SECURITY_CODE_REQUIRED',
  MAX_SECURITY_ATTEMPTS_EXCEEDED = 'MAX_SECURITY_ATTEMPTS_EXCEEDED',
  TOTP_INVALID = 'TOTP_INVALID',
  TWO_FA_TOO_MANY_ATTEMPTS = 'TWO_FA_TOO_MANY_ATTEMPTS',
  SMS_RETRY_LIMIT_REACHED = 'SMS_RETRY_LIMIT_REACHED',
  USER_SMS_DAILY_LIMIT_EXCEEDED = 'USER_SMS_DAILY_LIMIT_EXCEEDED',
  // Без S — отдельный код бэка, не путать с TOO_MANY_REQUESTS
  TOO_MANY_REQUEST = 'TOO_MANY_REQUEST',
  SMS_DISABLED = 'SMS_DISABLED',
  // Смена номера: 422 на /user/phone/{create,update} - неверный формат номера.
  INVALID_PHONE_NUMBER = 'INVALID_PHONE_NUMBER',
  ACTIVE_LIMIT_REACHED = 'ACTIVE_LIMIT_REACHED',
  INVALID_PIN_FORMAT = 'INVALID_PIN_FORMAT',
  PIN_MISMATCH = 'PIN_MISMATCH',
  WEAK_PIN = 'WEAK_PIN',
  SET_PIN_FAILED = 'SET_PIN_FAILED',
  CHAT_AUTH_UNAVAILABLE = 'CHAT_AUTH_UNAVAILABLE',
  // Коды роутинга онрампа v4 (POST /api/v4/buy/crypto/orders/h2h/aw): разовый и месячный лимиты
  // приходят разными кодами, легаси-версии ручки схлопывают их в общий набор.
  SINGLE_LIMIT_EXCEEDED = 'SINGLE_LIMIT_EXCEEDED',
  MONTHLY_LIMIT_EXCEEDED = 'MONTHLY_LIMIT_EXCEEDED',
  COUNTRY_NOT_SUPPORTED = 'COUNTRY_NOT_SUPPORTED',
  USER_NOT_FULLY_VERIFIED = 'USER_NOT_FULLY_VERIFIED',
}

export const getKnownErrorByHttpStatus = (status: number): API_KNOWN_ERRORS | undefined => {
  switch (status) {
    case HTTP_RESPONSE_CODE.TOO_MANY_REQUESTS:
      return API_KNOWN_ERRORS.RATE_LIMIT_EXCEEDED
    default:
      return undefined
  }
}
